module.exports = __webpack_public_path__ + "img/image23@2x.57e1f811.png";